import React from 'react';
import { motion } from 'framer-motion';
import {
  Calendar,
  Building2,
  Package,
  Pencil,
} from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { formatCurrency, formatDate, sumCantidad, sumSubtotal } from './format';

/**
 * Card de una entrega dentro del detalle/edición de una liquidación.
 * No tiene checkbox de selección (todas las entregas ya están guardadas),
 * pero permite abrir el dialog para ajustar precios si la liquidación
 * está en estado Borrador.
 */
const LiquidacionDetailCard = ({ entrega, editable, onOpenDetail }) => {
  if (!entrega) return null;
  const items = entrega.items || [];
  const totalItems = sumCantidad(items);
  const subtotal = sumSubtotal(items);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18 }}
    >
      <Card
        className={`border-l-4 border-l-emerald-500 ${
          editable ? 'cursor-pointer hover:shadow-md active:scale-[0.998] transition-all' : ''
        }`}
        onClick={editable ? () => onOpenDetail?.(entrega) : undefined}
      >
        <CardContent className="p-3">
          <div className="flex items-center gap-2 mb-1.5 flex-wrap">
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-700">
              E
            </span>
            <span className="font-semibold text-sm text-emerald-700">{entrega.consecutivo}</span>
            <Badge className="bg-emerald-100 text-emerald-700 text-xs">Entrega</Badge>
          </div>
          <p className="font-medium text-sm text-gray-900 truncate">
            {entrega.lavanderia?.nombre || '—'}
          </p>
          <div className="flex flex-wrap items-center gap-3 mt-1.5 text-xs text-gray-500">
            <span className="flex items-center gap-1">
              <Calendar className="h-3 w-3" /> {formatDate(entrega.fechaEntrega)}
            </span>
            <span className="flex items-center gap-1">
              <Package className="h-3 w-3" /> {totalItems} prendas
            </span>
            {entrega.lavanderia?.nombre && (
              <span className="flex items-center gap-1">
                <Building2 className="h-3 w-3" /> {entrega.lavanderia.nombre}
              </span>
            )}
          </div>
          <div className="flex items-center justify-between mt-3 pt-2 border-t border-gray-100">
            <div className="text-xs text-gray-500">
              <span className="text-gray-400">Subtotal:</span>{' '}
              <span className="text-base font-bold text-emerald-700">
                {formatCurrency(subtotal)}
              </span>
            </div>
            {editable && (
              <Button
                size="sm"
                variant="outline"
                className="gap-1.5 text-xs h-7"
                onClick={(e) => {
                  e.stopPropagation();
                  onOpenDetail?.(entrega);
                }}
              >
                <Pencil className="h-3 w-3" /> Ajustar precios
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default LiquidacionDetailCard;
